export default class Locale_AutoAlignContractNames {
	OnlyForNameMatch: string = "Only of names match";
	OnlyForNameMatchDescription: string = "Only align contract name, if the name of the contract is the same as the name of the generic resource.";
}